import BannerAward2024 from '../img/banner/Award2024.png';
import Title_Section1 from '../img/event/2510/title-main.png';
import Title_Section2 from '../img/event/2510/title-sec2.png';
import Online_Session from '../img/event/2510/online-session.png';
import PointBox from '../img/event/2510/point-box.png';
import icon_light from '../img/event/2510/icon-light.png';
import icon_family from '../img/event/2510/icon-family.png';
import icon_pray from '../img/event/2510/icon-pray.png';
import {
  EmojiChildrenLeftBox,
  EmojiChildrenRightBox,
} from './common/EmojiChildrenBox';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202510 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />
      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FFC85A]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-14 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 타이틀 섹션 */}
          <div className="flex flex-col items-center justify-center gap-10 sm:gap-14">
            {/* 타이틀 - 이미지 */}
            <div className="m-auto flex max-w-[720px] flex-col">
              <img
                src={Title_Section1}
                alt="추석 맞이 프로모션 어디서든 통하는 젭스 홈스쿨"
              />
            </div>

            {/* 말풍선 섹션 */}
            <section className="mx-auto flex w-[95%] min-w-[276px] max-w-[360px] flex-col justify-center gap-3 text-lg font-semibold sm:max-w-[480px] sm:gap-5">
              {/* 말풍선 1 */}
              <EmojiChildrenLeftBox
                icon={icon_light}
                text="이번 10월, 추석 연휴 이후
새롭게 시작하기 가장 좋은 때!"
                margin="10%"
                bgColor="bg-[#F26822]"
                textColor="text-white"
                iconBgColor="bg-[#F26822]"
                emojiRounded=""
                // customShadowStyle="0 7px 7px 4px rgba(255, 255, 255, 0.18) inset, 3px 5px 10px 2px rgba(0, 0, 0, 0.04)"
              >
                <>
                  이번 10월, 추석 연휴 이후
                  <br />
                  <span className="font-bold">
                    새롭게 시작하기 가장 좋은 때!
                  </span>
                </>
              </EmojiChildrenLeftBox>
              {/* 말풍선 2 */}
              <EmojiChildrenRightBox
                icon={icon_family}
                text="우리 가정에서 아이에게
신앙과 영어를 동시에 가르치고 싶다면?"
                margin="10%"
                bgColor="bg-[#F26822]"
                textColor="text-white"
                iconBgColor="bg-[#F26822]"
                emojiRounded=""
                // customShadowStyle="0 7px 7px 4px rgba(255, 255, 255, 0.18) inset, 3px 5px 10px 2px rgba(0, 0, 0, 0.04)"
              >
                <>
                  우리 가정에서 아이에게 <br />
                  <span className="font-bold">
                    신앙과 영어를 동시에 가르치고 싶다면?
                  </span>
                </>
              </EmojiChildrenRightBox>
              {/* 말풍선 3 */}
              <EmojiChildrenLeftBox
                icon={icon_pray}
                text="교회나 공부방에서 다음세대 아이들에게
말씀과 영어를 함께 가르치고 싶다면?"
                margin="10%"
                bgColor="bg-[#F26822]"
                textColor="text-white"
                iconBgColor="bg-[#F26822]"
                emojiRounded=""
                // customShadowStyle="0 7px 7px 4px rgba(255, 255, 255, 0.18) inset, 3px 5px 10px 2px rgba(0, 0, 0, 0.04)"
              >
                <>
                  교회나 공부방에서 다음세대 아이들에게
                  <br />{' '}
                  <span className="font-bold">
                    말씀과 영어를 함께 가르치고 싶다면?
                  </span>
                </>
              </EmojiChildrenLeftBox>
            </section>
            <div className="bg-black px-2 text-center text-lg font-bold text-white sm:py-1 sm:text-2xl">
              👉 젭스 홈스쿨 하나면 가능합니다!
            </div>
          </div>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 타이틀 텍스트 */}
              <div className="text-2xl font-extrabold sm:text-4xl">
                어디서든 시청할 수 있는 설명회
              </div>
              {/* 서브타이틀 텍스트 */}
              <div className="text-lg font-medium text-black sm:text-2xl">
                핵심만 꼭꼭 눌러 담은 알찬 젭스 활용법!{' '}
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어성경홈스쿨 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-[#F26A24]"
              hoverBgColor="hover:bg-[#F98228]/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#F26A24]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col items-center gap-10 py-14 sm:gap-14 sm:py-20">
          {/* 타이틀 */}
          <section className="flex flex-col gap-1 sm:gap-3">
            <div className="mx-5 max-w-[480px] sm:m-auto">
              <img src={Title_Section2} alt="Title_Section2" />
            </div>
            <div className="text-center text-lg font-bold text-white sm:text-2xl">
              ~10.31(금) 까지
            </div>
          </section>

          {/* 이미지 */}
          <div className="ml-3 grid grid-cols-[1fr_auto] items-center gap-3 xs:ml-5">
            <img
              src={PointBox}
              alt="공부방 패키지"
              className="max-w-[160px] sm:max-w-[240px] xs:max-w-[240px]"
            />
          </div>

          {/* 디스크립션 섹션 */}
          <div className="flex flex-col gap-3">
            <div className="text-center text-xl font-bold text-black sm:text-3xl">
              <span className="bg-black px-2 text-[#FFC85A]">
                ✓ 최대 10만원
              </span>{' '}
              포인트 페이백
            </div>
            <div className="text-center text-lg font-medium text-black sm:text-2xl">
              혜택은 단 한 번, 배움은 평생!
              <br /> 지금 바로 추석 혜택과 함께 시작하세요!
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="relative flex items-center justify-center bg-[#FFD67E]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="relative flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-16 sm:py-20">
          {/* 박스 */}
          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <TextBox>
              <div className="m-0 font-bold text-black">
                젭스 홈스쿨의 성경 기반 영어 콘텐츠
                <br />
                <span className="text-[#F26A24]">
                  → 모든 공간에서 운영 가능
                </span>
              </div>
            </TextBox>
            <TextBox>
              <div className="font-bold text-black">
                말씀 암송 + 영어 학습
                <br />
                <span className="text-[#F26A24]">
                  → 믿음과 실력을 동시에 성장
                </span>
              </div>
            </TextBox>
            <TextBox>
              <div className="m-0 font-bold text-black">
                추석 맞이 특별 프로모션
                <br />
                <span className="text-[#F26A24]">
                  → 지금 시작하는 분께 최대 혜택 제공
                </span>
              </div>
            </TextBox>
          </section>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              10월 등록 혜택 확인
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202510;
